import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { activityDevireLtvCurrencyOther } from "@/api/dataAll/accountLtv";
import * as echarts from "echarts";
export default {
  name: "dataLtvac",
  mixins: [tabulation],
  data: function data() {
    return {
      value2: [],
      tableData: [],
      dates: [],
      series: [],
      intReq: [],
      Dynamic: [],
      PrimitiveDy: [],
      screen: [],
      cellStylekeys: ["LTV"]
    };
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.kind = 1;
                _this.PrimitiveDy = [];

                _this.searchClickPoints(activityDevireLtvCurrencyOther, 1);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      var qres = JSON.parse(JSON.stringify(lists));
      var res = {
        data: {
          device_total: 0,
          ltv_data: {},
          ltv_total: {}
        }
      };
      qres.forEach(function (i) {
        res.data.device_total = res.data.device_total + i.device_total;
        res.data.ltv_data = _objectSpread(_objectSpread({}, res.data.ltv_data), i.ltv_data);

        for (var k in i.ltv_total) {
          var nums = Number(i.ltv_data[i.searchdate.starttime].amount[k]);
          res.data.ltv_total[k] = !res.data.ltv_total[k] ? nums : res.data.ltv_total[k] + nums;
        }
      }); // if(this.currencyClose && !this.searchData.currency_info){
      //   this.$message.error('请选择货币类型')
      //   return
      // }

      for (var i in res.data.ltv_total) {
        res.data.ltv_total[i] = res.data.device_total ? res.data.ltv_total[i] / res.data.device_total : 0;
      }

      this.timeInterval();
      this.tableData = [];
      this.series = [];
      this.dates = [];
      this.screen = [];
      delete res.data.ltv_total['0'];
      res.data.ltv_data[this.$t('total')] = {
        ltv: res.data.ltv_total,
        other: {
          new_device_num: res.data.device_total
        }
      };

      for (var k in res.data.ltv_data) {
        var data = {
          date: k,
          new_device_num: res.data.ltv_data[k].other.new_device_num
        };
        this.dates.push(k);
        var obj = {
          name: k,
          type: "line",
          data: [],
          smooth: true
        };
        var DynamicList = [];
        var length = Object.keys(res.data.ltv_data[k].ltv).length;

        for (var j in res.data.ltv_data[k].ltv) {
          data['LTV' + j] = res.data.ltv_data[k].ltv[j] == '/' ? 0.000 : this.$utils.conversion(res.data.ltv_data[k].ltv[j]).toFixed(3);
          obj.data.push(data['LTV' + j]);

          if (DynamicList.length < length) {
            var headerLabel = this.$t('activateDeviceLtv', {
              day: j
            });
            DynamicList.push({
              label: headerLabel,
              prop: 'LTV' + j,
              tableText: j == 1 ? headerLabel + 'A' : headerLabel,
              desc: j == 1 ? this.$t('firstDayActivateDeviceAvgValue') : ''
            });
          }
        }

        if (!this.screen.length) {
          this.screen = DynamicList.map(function (item) {
            return item.prop;
          });
        }

        this.PrimitiveDy = DynamicList;
        this.screenControls();
        this.series.push(obj);
        this.tableData.push(data);
      }

      this.$nextTick(function () {
        _this2.getechart();

        _this2.getTableRight();
      });
    },
    screenControls: function screenControls() {
      var _this3 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this3.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this3.Dynamic = list;
      }, 20);
      this.setTableRight(0);
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("dataLtvacEchart");
      var myChart = echarts.init(chartDom);
      var option;
      var dateCp = JSON.parse(JSON.stringify(this.dates)).splice(0, this.dates.length - 1);
      option = {
        title: {
          text: this.$t('activateDeviceLtvTitle')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: dateCp,
          width: '80%'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.prop;
          })
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('newActivateDevice'),
        prop: 'new_device_num'
      }].concat(_toConsumableArray(this.Dynamic));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};